// src/pages/SuaMayGiat.js
import React from "react";
import "./Maygiat.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

// Thay các đường dẫn dưới đây bằng ảnh thật của bạn
import heroImg from "../assets/maygiat1.png";
import issueImg from "../assets/maygiat2.png";
import serviceImg from "../assets/maygiat3.png";
import processImg from "../assets/maygiat4.png";

const hotline = "0994 307 835";

export default function Maygiat() {
  return (
    <div className="wm-page">
      <div className="wm-container">
        {/* TIÊU ĐỀ + GIỚI THIỆU */}
        <section className="wm-header">
          <Navbar />
          <h1 className="wm-title">
            Dịch vụ Sửa Máy Giặt Uy tín – Chất lượng – Thợ tận tâm
          </h1>
          <p className="wm-intro">
            Điện Lạnh Sài Gòn chuyên sửa máy giặt tại nhà Thành phố Hồ Chí Minh
            và các vùng lân cận. Chúng tôi cam kết dịch vụ Uy tín – Chất lượng –
            Thợ tận tâm, lành nghề. Khách hàng có nhu cầu vui lòng liên hệ{" "}
            <strong>HOTLINE {hotline}</strong> để được hỗ trợ tư vấn!
          </p>

          <button className="wm-hotline-btn">HOTLINE: {hotline}</button>

          <div className="wm-hero-wrapper">
            <img
              className="wm-hero-img"
              src={heroImg}
              alt="Thợ sửa máy giặt tại nhà"
            />
          </div>
        </section>

        {/* KHI NÀO CẦN GỌI THỢ */}
        <section className="wm-section">
          <h2 className="wm-section-title">
            Khi nào cần gọi thợ sửa chữa máy giặt?
          </h2>
          <p>
            Sau nhiều năm <strong>sửa máy giặt</strong>, chúng tôi đưa ra một số
            lỗi phổ biến để bạn biết khi nào nên gọi thợ đến sửa chữa:
          </p>
          <ul className="wm-list">
            <li>Máy giặt bị mất nguồn và bật không lên.</li>
            <li>Máy giặt bị liệt bàn phím.</li>
            <li>Máy giặt không cấp nước.</li>
            <li>Máy giặt báo lỗi nhấp nháy đèn liên tục.</li>
            <li>Máy giặt rung lắc mạnh, kêu to.</li>
            <li>Máy giặt không vắt hoặc vắt rất yếu.</li>
            <li>Máy giặt không xả nước.</li>
            <li>Board mạch báo lỗi, không hoạt động.</li>
            <li>Máy giặt bị rò điện khi sử dụng.</li>
            <li>Thời gian giặt quá lâu, chương trình giặt không kết thúc,…</li>
          </ul>

          <div className="wm-center">
            <button className="wm-hotline-btn wm-btn-large">
              GỌI THỢ SỬA MÁY GIẶT
            </button>
          </div>

          <div className="wm-image-wrapper">
            <img
              className="wm-image"
              src={issueImg}
              alt="Các lỗi thường gặp trên máy giặt"
            />
          </div>
        </section>

        {/* DỊCH VỤ TẠI NHÀ */}
        <section className="wm-section">
          <h2 className="wm-section-title">
            Dịch vụ Sửa Máy Giặt Tại Nhà – Điện Lạnh Sài Gòn
          </h2>
          <ul className="wm-list">
            <li>
              <strong>Gọi là đến siêu tốc:</strong> Đội ngũ thợ đông đảo khắp
              TP.HCM, có mặt sau 30 phút.
            </li>
            <li>
              <strong>Khắc phục triệt để hư hỏng:</strong> Cam kết sửa triệt để,
              không tái phát, tiết kiệm chi phí cho khách hàng.
            </li>
            <li>
              <strong>Phục vụ tận tâm:</strong> Thợ luôn nhiệt tình, tư vấn rõ
              ràng, trung thực.
            </li>
            <li>
              <strong>Linh kiện chính hãng:</strong> 100% sử dụng linh kiện
              chuẩn, có bảo hành rõ ràng.
            </li>
            <li>
              <strong>Giá rẻ, minh bạch:</strong> Báo giá trước khi làm, không
              phát sinh chi phí.
            </li>
            <li>
              <strong>Bảo hành dài lâu:</strong> Bảo hành từ 3 – 12 tháng tùy
              hạng mục sửa chữa.
            </li>
            <li>
              <strong>Hỗ trợ 24/24:</strong> Phục vụ cả ngày lễ, Tết khi khách
              hàng cần gấp.
            </li>
          </ul>

          <div className="wm-image-wrapper">
            <img
              className="wm-image"
              src={serviceImg}
              alt="Khách hàng hài lòng sau khi sửa máy giặt"
            />
          </div>
        </section>

        {/* ƯU ĐIỂM / CAM KẾT */}
        <section className="wm-section">
          <p className="wm-highlight">
            Điện Lạnh Sài Gòn –{" "}
            <em>
              Địa chỉ bảo trì sửa chữa máy giặt uy tín, được khách hàng đánh giá
              cao
            </em>
          </p>

          <div className="wm-benefit-grid">
            <div className="wm-benefit-item">
              <h3>Thợ có chứng chỉ nghề</h3>
              <p>
                Đội ngũ kỹ thuật viên được đào tạo bài bản, thường xuyên cập
                nhật kiến thức mới để xử lý tốt mọi dòng máy giặt trên thị
                trường.
              </p>
            </div>
            <div className="wm-benefit-item">
              <h3>Quy trình sửa chữa chuẩn</h3>
              <p>
                Sử dụng linh kiện chất lượng cao, sửa chữa theo đúng khuyến cáo
                của hãng sản xuất giúp máy hoạt động ổn định lâu dài.
              </p>
            </div>
            <div className="wm-benefit-item">
              <h3>Giữ hiện trường sạch sẽ</h3>
              <p>
                Kỹ thuật viên luôn dọn dẹp khu vực làm việc, giữ vệ sinh nhà bạn
                trước khi rời đi.
              </p>
            </div>
            <div className="wm-benefit-item">
              <h3>Bảo hành 12 tháng</h3>
              <p>
                Bảo hành kết quả công việc 12 tháng, giúp khách hàng an tâm khi
                lựa chọn dịch vụ của chúng tôi.
              </p>
            </div>
          </div>

          <div className="wm-center">
            <button className="wm-hotline-btn wm-btn-large">
              GỌI {hotline}
            </button>
          </div>
        </section>

        {/* QUY TRÌNH SỬA MÁY GIẶT */}
        <section className="wm-section">
          <h2 className="wm-section-title">
            Quy trình Sửa Máy Giặt – Điện Lạnh Sài Gòn
          </h2>
          <p>
            Chúng tôi mang đến cho quý khách trải nghiệm dịch vụ chuyên nghiệp,
            chất lượng với quy trình làm việc nhanh chóng, kỹ càng bao gồm 4
            bước cơ bản:
          </p>
          <ol className="wm-list wm-ordered">
            <li>
              <strong>Bước 1 – Tiếp nhận thông tin:</strong> Nhận thông tin trực
              tiếp qua hotline, tư vấn sơ bộ và đặt lịch hẹn.
            </li>
            <li>
              <strong>Bước 2 – Kiểm tra &amp; báo giá:</strong> Kỹ thuật đến tận
              nơi, kiểm tra tình trạng máy và đưa ra báo giá chi tiết.
            </li>
            <li>
              <strong>Bước 3 – Tiến hành sửa chữa:</strong> Sau khi khách đồng
              ý, thợ tiến hành sửa chữa đúng cam kết, thay thế linh kiện (nếu
              cần).
            </li>
            <li>
              <strong>Bước 4 – Bàn giao &amp; thanh toán:</strong> Vận hành kiểm
              tra lần cuối, bàn giao, viết hóa đơn và hướng dẫn sử dụng, bảo
              hành.
            </li>
          </ol>

          <div className="wm-image-wrapper">
            <img
              className="wm-image"
              src={processImg}
              alt="Quy trình sửa máy giặt"
            />
          </div>
        </section>

        {/* GỌI THỢ THEO QUẬN */}
        <section className="wm-section wm-last">
          <h2 className="wm-section-title">
            Gọi Thợ Sửa Máy Giặt tại nhà nhanh chóng.
          </h2>
          <p>Bấm gọi chi nhánh gần quý khách để được phục vụ tốt nhất!</p>

          <div className="wm-district-grid">
            <div className="wm-district-col">
              <p>Gọi thợ Sửa Máy Giặt tại Quận 1</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 2</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 3</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 4</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 5</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 6</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 7</p>
            </div>
            <div className="wm-district-col">
              <p>Gọi thợ Sửa Máy Giặt tại Quận 8</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 9</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 10</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 11</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận 12</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận Gò Vấp</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận Phú Nhuận</p>
            </div>
            <div className="wm-district-col">
              <p>Gọi thợ Sửa Máy Giặt tại Quận Tân Bình</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận Bình Thạnh</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận Bình Tân</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận Thủ Đức</p>
              <p>Gọi thợ Sửa Máy Giặt tại Quận Tân Phú</p>
              <p>Gọi thợ Sửa Máy Giặt tại Hóc Môn</p>
              <p>Gọi thợ Sửa Máy Giặt tại Nhà Bè</p>
            </div>
          </div>

          <p className="wm-footer-note">
            Quý khách hàng đang có nhu cầu <strong>sửa máy giặt tại nhà</strong>{" "}
            có thể liên hệ trực tiếp đến <strong>Điện Lạnh Sài Gòn</strong> qua
            số <strong>Tổng Đài {hotline}</strong>, chúng tôi sẽ cử kỹ thuật
            viên chuyên môn cao hỗ trợ bạn sớm nhất.
          </p>
          <Footer />
        </section>
      </div>
    </div>
  );
}
